import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import List from '@mui/material/List';
import { styled } from '@mui/material/styles';

export const RootBox = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    paddingLeft: '10rem',
    paddingRight: '10rem'
  }
}));

export const LogoBox = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: '3rem',
  right: '3rem',
  width: '9rem',
  img: {
    width: '100%',
    height: 'auto'
  },
  [theme.breakpoints.up('md')]: {
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    justifyContent: 'center',
    width: '10rem'
  }
}));

export const TextContainer = styled(Container)(() => ({
  padding: '0 1rem 1.25rem'
}));

export const TitleContainer = styled(Container)(({ theme }) => ({
  paddingTop: '2.5rem',
  paddingBottom: '2.5rem',
  [theme.breakpoints.up('md')]: {
    paddingTop: '3rem'
  }
}));

export const InstructionsList = styled(List)(({ theme }) => ({
  listStyle: 'decimal',
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: '1.5rem',
  [theme.breakpoints.up('lg')]: {
    minHeight: '13.5rem'
  }
}));

export const InstallationImagesBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '1.25rem',
  paddingTop: '1.25rem',
  paddingBottom: '1.25rem',
  [theme.breakpoints.up('md')]: {
    paddingTop: '3rem',
    paddingBottom: '4rem',
    gap: '2.5rem'
  }
}));

export const ButtonContainer = styled(Container)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  paddingTop: '0.75rem',
  paddingBottom: '2rem',
  [theme.breakpoints.up('md')]: {
    paddingTop: '3rem',
    paddingBottom: '4rem'
  }
}));
